// extracted by mini-css-extract-plugin
module.exports = {"container":"BasicInfoView_container__3nDw1","title":"BasicInfoView_title__3_Zvv","description":"BasicInfoView_description__3m2db"};